<template>
  <div
    ref="svgContainer"
    class="w-full bg-[#FCFCFC] rounded-lg p-4"
    v-html="svg"
  />
</template>

<script>
export default {
  name: 'WorldMapSelect',
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      svg: ''
    }
  },
  methods: {
    async loadSVG () {
      const res = await fetch(require('@builder/assets/svg/world.svg'))
      this.svg = await res.text()
    },
    toggleCountry (country) {
      const code = country.id
      const newSelection = this.value ? [...this.value] : []
      const index = newSelection.indexOf(code)

      if (index > -1) {
        newSelection.splice(index, 1)
        country.classList.remove('selected-country')
      } else {
        newSelection.push(code)
        country.classList.add('selected-country')
      }

      this.$emit('input', newSelection)
      this.$emit('update:value', newSelection)
    },
    updateSvgSelection (codes) {
      const svgEl = this.$refs.svgContainer?.querySelector('svg')
      if (!svgEl) return

      const countries = svgEl.querySelectorAll('path')
      countries.forEach(country => {
        return country.classList.toggle('selected-country', codes.includes(country.id))
      })
    }
  },
  watch: {
    value (newVal) {
      this.updateSvgSelection(newVal)
    }
  },
  async mounted () {
    await this.loadSVG()
    this.$nextTick(() => {
      setTimeout(() => {
        const svgEl = this.$refs.svgContainer?.querySelector('svg')
        if (!svgEl) return

        svgEl.setAttribute('width', '100%')
        svgEl.removeAttribute('height')
        svgEl.style.height = 'auto'
        svgEl.setAttribute('preserveAspectRatio', 'xMidYMid meet')
        svgEl.setAttribute('fill', '#466BB1')
        svgEl.setAttribute('stroke', '#466BB1')
        svgEl.setAttribute('stroke-width', '2.5')
        svgEl.style.display = 'block'

        const countries = svgEl.querySelectorAll('path')
        const tooltip = document.createElement('div')
        tooltip.style.position = 'absolute'
        tooltip.style.background = '#333'
        tooltip.style.color = '#fff'
        tooltip.style.padding = '4px 8px'
        tooltip.style.borderRadius = '4px'
        tooltip.style.pointerEvents = 'none'
        tooltip.style.fontSize = '12px'
        tooltip.style.display = 'none'
        document.body.appendChild(tooltip)

        countries.forEach(country => {
          // country.addEventListener('click', () => {
          //   this.toggleCountry(country)
          // })

          country.addEventListener('mouseenter', () => {
            tooltip.innerText = country.getAttribute('name') || country.className.baseVal
            tooltip.style.display = 'block'
          })

          country.addEventListener('mousemove', (e) => {
            tooltip.style.left = `${e.pageX + 10}px`
            tooltip.style.top = `${e.pageY + 10}px`
          })

          country.addEventListener('mouseleave', () => {
            tooltip.style.display = 'none'
          })
        })

        this.updateSvgSelection(this.value)
      }, 0)
    })
  }
}
</script>

<style>
path {
  cursor: pointer;
  transition: fill 0.2s ease;
}

path:hover {
  opacity: .8;
}

.selected-country {
  fill: #3D82EA !important;
  stroke: #3D82EA !important;
}
</style>
